import { gql } from "@apollo/client";
import useData from "hooks/useData";
import { Mail } from "mdi-material-ui";
import React from "react";
import makeConfirmActionDialog from "readmin_pages/shared/makeConfirmActionDialog";

export const PeopleSendWelcomeEmailDialog = makeConfirmActionDialog({
  mutationName: "peopleSendWelcomeEmail",
  paramName: "personId",
  action: "Send Welcome Email",
  useButtonProps: ({ personId }) => {
    const [data] = useData(
      gql`
        query PeopleSendWelcomeEmail($personId: ID!) {
          person(id: $personId) {
            id
            withinWelcomeEmailCoolDownPeriod
          }
        }
      `,
      { personId },
    );
    return {
      icon: <Mail />,
      disabled: !data || data.person.withinWelcomeEmailCoolDownPeriod,
      content: "Send Welcome Email",
    };
  },
});
